var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.guests)?_c('router-view'):_c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.resourcesLoaded)?_c('router-view'):_c('loader')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }